<app-header-one [class]="'header-gym'"></app-header-one>
<app-subheader></app-subheader>
<!--app-separator [color]="'light'"></app-separator-->
<!-- Home slider start-->
<section class="p-0 gym-slider">
  <div class="container">
    <h3 class="text-center">Condividi la tua posizione</h3>
    <h4 class="text-center">Vedrai tutti i ristoranti disponibili vicino a te</h4>
    <div class="row justify-content-center pt-3 mt-5">
      <div class="col-lg-4 my-1"><button class="btn btn-solid btn-block" (click)="getPosition()">Condividi posizione</button></div>
      <div class="col-lg-1 my-1 text-center d-flex align-items-center justify-content-center">oppure</div>
      <div class="col-lg-4 my-1">
        <div class="address-container">
          <!-- <input ngx-google-places-autocomplete [options]='options' [(ngModel)]="query" #placesRef="ngx-places"
                (onAddressChange)="handleAddressChange($event)" class="form-control mb-2 mt-3" #geosearch
                (keyup.enter)="searchenter()" placeholder="Inserisci il tuo indirizzo"> -->
          <button class="btn btn-solid mini-button" (click)="onGo(-1)">VAI</button>
        </div>
      </div>
    </div>
  </div>

</section>
<!-- Home slider End -->

<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>